import React, { useContext, useEffect } from "react";
import "./ComparePlansModal.css";
import { Form, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import RedRoundBtn from "../../Common_Btn/RedRoundBtn/RedRoundBtn";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { useState } from "react";

const ComparePlansModal = ({
  selectedPlansdata,
  insuranceData,
  data,
  ...props
}) => {
  const plans = [
    {
      title: "Bajaj Allianz Life iSecure II",
      img: "/assets/Image/aboutus/partner/img1.png",
      price: "₹ 731",
    },
    {
      title: "PNB Metlife",
      img: "/assets/Image/aboutus/partner/img2.png",
      price: "₹ 954",
    },
    {
      title: "HDFC Bank",
      img: "/assets/Image/aboutus/partner/img3.png",
      price: "₹ 630",
    },
    {
      title: "IDBI Bank",
      img: "/assets/Image/aboutus/partner/img4.png",
      price: "₹ 775",
    },
  ];

  const navigate = useNavigate();
  const { IMG_URL } = useContext(Context);
  const [selectedPlans, setSelectedPlans] = useState([]);

  const handleCheckboxChange = (item) => {
    const isSelected = selectedPlans?.find((plan) => plan.id === item.id);

    if (isSelected) {
      // Remove from selection
      setSelectedPlans((prev) => prev.filter((plan) => plan.id !== item.id));
    } else {
      // Add to selection (limit 3)
      if (selectedPlans?.length < 3) {
        setSelectedPlans((prev) => [...prev, item]);
      } else if((selectedPlans?.length >= 3)) {
        alert("You can only compare up to 3 plans.");
      } 
    }
  };

  const handleCompareClick = () => {
    // You can pass selectedPlans to another route using navigation state
    if (selectedPlans.length < 2) {
        alert("You must select at least 2 plans.");
        return;
      }
  
    navigate("/plan-compare", {
      state: { selectedPlans, insuranceData, data },
    });
    props.onHide();
  };

  useEffect(() => {
    if (selectedPlansdata) {
      setSelectedPlans(selectedPlansdata);
    }
  }, [selectedPlansdata]);

  return (
    <section className="ComparePlansModal">
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="ComparePlansModal common_modal"
      >
        <Modal.Header>
          <Modal.Title>
            Choose Plans to Compare{" "}
            <span className="inner_title">(max. 3 plans can be compared)</span>
          </Modal.Title>
          <div
            className="close_icon_holder"
            onClick={() => {
              props?.onHide();
            }}
          >
            <FontAwesomeIcon icon={faXmark} className="close_icon" />
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="content_holder">
            <div className="plan_card_main_holder">
              <div className="row">
                {insuranceData?.data?.map((item) => {
                  const isChecked = selectedPlans?.some(
                    (plan) => plan.id === item.id
                  );
                  return (
                    <div className="col-lg-4 col-md-6 col-sm-6">
                      <div className="plan_card">
                        <div className="top_part">
                          <div className="logo_holder">
                            <img
                              src={IMG_URL + item?.image}
                              className="logo_img"
                            />
                          </div>

                          <p className="red_checkobox">
                            <Form.Check
                              type="checkbox"
                              name="compare"
                              checked={isChecked}
                              onChange={() => handleCheckboxChange(item)}
                            />
                          </p>
                        </div>

                        <div className="bottom_part">
                          <div className="comapany_name_div">
                            <p className="text">{item?.name}</p>
                          </div>
                          <div className="price_div">
                            <p className="price">{item?.price}</p>
                            <p className="monthly_text">monthly</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="compare_btn_holder">
              <RedRoundBtn btn_name="Compare" onClick={handleCompareClick} />
              {/* <RedRoundBtn btn_name="Compare" onClick={() => {navigate("/plan-compare")}}/> */}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default ComparePlansModal;
